import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  card: {
    height: 250,
    width: 400,
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  textField: {
    width: 300,
  },
  title: {
    marginBottom: 16,
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
});

class LoginForm extends Component {
  state = {
    username: '',
    password: '',
  };
  
  render() {
    const { classes } = this.props;
    return (
      <Grid container className={classes.root}>
        <Card className={classes.card}>
          <CardContent className={classes.cardContent}>
            <TextField
              id="username"
              label="Usuário"
              value={this.state.name}
              className={classes.textField}
              onChange={(event) => this.setState({ username: event.target.value })}
              margin="normal"
            />
            <TextField
              id="password"
              label="Senha"
              type="password"
              className={classes.textField}
              value={this.state.password}
              onChange={(event) => this.setState({ password: event.target.value })}
              margin="normal"
            />
          </CardContent>
          <CardActions className={classes.cardContent}>
            <Button color="primary" onClick={this.doLogin}>ENTRAR</Button>
          </CardActions>
        </Card>
      </Grid>
    );
  }

  doLogin = () => {
    this.props.doLogin(this.state);
  }
}

export default withStyles(styles)(LoginForm);



// WEBPACK FOOTER //
// ./src/login/components/LoginForm.jsx